"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_MOBILE_ITEMS = exports.MAX_DESKTOP_ITEMS = exports.FLAT_SELECTION_UI_FT_GUID = void 0;
const FLAT_SELECTION_UI_FT_GUID = exports.FLAT_SELECTION_UI_FT_GUID = 'DC9C5A5E-52A0-498A-A25D-03417FCEA8F8';
const MAX_MOBILE_ITEMS = exports.MAX_MOBILE_ITEMS = 4;
const MAX_DESKTOP_ITEMS = exports.MAX_DESKTOP_ITEMS = 7;